import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { ButtonText, MicrosoftSignInDiv, ImageWrapper } from './MicrosoftLoginButton.styles';
// @ts-expect-error not converted to TS
import Image from '../../images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MicrosoftLoginButton = ({
  onClick,
  smartLogin,
  disabled,
  tooltipDisabled = true
}) => /*#__PURE__*/_jsx(UITooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "login.smartLogin.disabledButtonHelp"
  }),
  disabled: tooltipDisabled,
  children: /*#__PURE__*/_jsx(UIButton, {
    className: "microsoft-sign-in width-100 m-left-0",
    "data-test-id": "microsoft-sign-in",
    use: "unstyled",
    onClick: onClick,
    disabled: disabled,
    children: /*#__PURE__*/_jsxs(MicrosoftSignInDiv, {
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(ImageWrapper, {
        disabled: disabled,
        children: /*#__PURE__*/_jsx(UIImage, {
          src: Image.microsoftLogo
        })
      }), /*#__PURE__*/_jsx(ButtonText, {
        smartLogin: smartLogin,
        children: smartLogin ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.microsoft"
        }) : /*#__PURE__*/_jsx(UITruncateString, {
          className: "width-100",
          reverse: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.form.microsoft"
          })
        })
      })]
    })
  })
});